// globalFunc.js
import { EventBus } from './eventBus'

export default {
  install (Vue) {
    Vue.prototype.connectWebSocket = function () {
      const token = this.generateJwtToken()
      this.GLOBAL.socket = new WebSocket(this.GLOBAL.SOCKET_URL, [token])

      this.GLOBAL.socket.addEventListener('open', (event) => {
      })

      this.GLOBAL.socket.addEventListener('message', (event) => {
        const receivedData = JSON.parse(event.data)
        this.$set(this.GLOBAL, 'date', receivedData.date)
        this.$set(this.GLOBAL, 'tableList', receivedData.priceData)
        EventBus.$emit('dateUpdated', this.GLOBAL.date)
        EventBus.$emit('tabListUpdated', this.GLOBAL.tableList)
      })

      const closeHandler = (event) => {
        this.startReconnectInterval()
      }
      this.GLOBAL.socket._closeHandler = closeHandler
      this.GLOBAL.socket.addEventListener('close', closeHandler)

      this.GLOBAL.socket.addEventListener('error', (event) => {
        console.error('WebSocket error:', event)
      })
    }
    Vue.prototype.generateJwtToken = function () {
      if (!this.GLOBAL.token) {
        console.error('JWT token is missing.')
        throw new Error('JWT token is missing.')
      }

      const payload = {
        'user': 'djyj',
        'exp': Math.floor(Date.now() / 1000) + 60 * 60
      }
      const jwt = require('jsonwebtoken')
      return jwt.sign(payload, this.GLOBAL.token)
    }

    Vue.prototype.reconnectWebSocket = function () {
      if (!this.GLOBAL.socket || this.GLOBAL.socket.readyState !== WebSocket.OPEN) {
        this.connectWebSocket()
      }
    }
    Vue.prototype.startReconnectInterval = function () {
      clearInterval(this.GLOBAL.reconnectInterval)
      this.GLOBAL.reconnectInterval = setInterval(() => {
        this.reconnectWebSocket()
      }, 5000)
    }
    Vue.prototype.closeWebSocket = function () {
      clearInterval(this.GLOBAL.reconnectInterval)
      if (this.GLOBAL.socket) {
        if (this.GLOBAL.socket._closeHandler) {
          this.GLOBAL.socket.removeEventListener('close', this.GLOBAL.socket._closeHandler)
          delete this.GLOBAL.socket._closeHandler
        }
        if (this.GLOBAL.socket.readyState === WebSocket.OPEN || this.GLOBAL.socket.readyState === WebSocket.CONNECTING) {
          this.GLOBAL.socket.close()
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/globalFunc.js